import React, { createContext, useState } from 'react';
import { IntercomProvider as ReactIntercomProvider } from 'react-use-intercom';

import { getPortalRuntimeConfig } from '../../services/runtimeConfig';

export const intercomContext = createContext<{
  intercomUnreadMessagesCount: number;
}>({
  intercomUnreadMessagesCount: 0,
});

const IntercomProvider = ({ children }: { children?: React.ReactNode }) => {
  const [intercomUnreadMessagesCount, setIntercomUnreadMessagesCount] = useState<number>(0);

  const onUnreadCountChange = (amount: number) => setIntercomUnreadMessagesCount(amount);
  const appId = getPortalRuntimeConfig().intercom.appId ?? '';

  return (
    <ReactIntercomProvider appId={appId} onUnreadCountChange={onUnreadCountChange}>
      <intercomContext.Provider
        value={{
          intercomUnreadMessagesCount,
        }}
      >
        {children}
      </intercomContext.Provider>
    </ReactIntercomProvider>
  );
};

export default IntercomProvider;
